<template>
  <div class="tab-content" v-if="active">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabbedViewItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content {
    flex: 1;
}
</style>
